import type { HelpFile } from '../../types/help'
import { RequestInspectorTestIds } from '../../../testids/RequestInspectorTestIds'

export const requestInspectorHelp: HelpFile = {
  docPage: '/docs/admin/request-inspector',
  texts: {
    [RequestInspectorTestIds.requestInspectorPage]:
      'Aufgezeichnete Request-Sitzungen — jede Zeile bündelt alle HTTP-, SQL-, Frontend- und Service-Aufruf-Spans einer Session für lückenloses Tracing.',
    [RequestInspectorTestIds.requestInspectorList]:
      'Volltextsuche findet nur Operationsnamen und HTTP-URLs — Diagnosefelder sind bewusst ausgeschlossen.',
    [RequestInspectorTestIds.tracesTable]:
      'Eine Zeile pro aufgezeichneter Sitzung — Klick öffnet den vollständigen Span-Wasserfall.',
    [RequestInspectorTestIds.colSessionId]: 'Session-ID, die alle Spans derselben Anfrage verbindet.',
    [RequestInspectorTestIds.colEarliestStartedAt]: 'Zeitstempel des ersten Spans — Beginn der Anfrage.',
    [RequestInspectorTestIds.colTotalDuration]: 'Dauer vom Start des ersten bis zum Ende des letzten Spans.',
    [RequestInspectorTestIds.colSpanCount]: 'Anzahl aufgezeichneter Spans — hohe Werte deuten auf Fan-out- oder N+1-Muster hin.',
    [RequestInspectorTestIds.colErrorCount]: 'Anzahl der Spans mit Fehler.',
    [RequestInspectorTestIds.pageLayoutFilters]: null,
    [RequestInspectorTestIds.inspectorMinQHint]: 'Volltextsuche erfordert mindestens drei Zeichen.',
    [RequestInspectorTestIds.inspectorSearchScopeHint]: 'Suche findet nur Operationsnamen und HTTP-URLs — Diagnosefelder sind ausgeschlossen.',
    [RequestInspectorTestIds.writerOfflineAlert]: 'Trace-Writer ist offline — neue Sitzungen werden nicht aufgezeichnet.',
    [RequestInspectorTestIds.emptyStateCard]: 'Keine Request-Sitzungen entsprechen den aktuellen Filtern.',
  },
}
